var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Spot"
  }, [_c('InputFieldWithLabel', {
    attrs: {
      "isRequired": _vm.required,
      "label": _vm.label,
      "options": _vm.itemsFormatted,
      "value": _vm.tempValue
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }